/**
 * Copy constants for guest guard sign-up prompts and guest-only UI.
 */

/** Groups tab on Friends dashboard / create when Groups is disabled for guests. */
export const GUEST_GROUPS_TAB_ACCESSIBILITY_LABEL = 'Groups, sign in to use';

export const GUEST_PROMPT_COPY = {
  TITLE: 'Join Zporti',
  MESSAGE_PREFIX: 'Sign up to ',
  CONFIRM: 'Sign Up Free',
  CANCEL: 'Maybe Later',
} as const;

/** Appended after MESSAGE_PREFIX in requireAuth(action). Keep lowercase sentence fragments. */
export const GUEST_AUTH_ACTIONS = {
  DAILY_REWARD: 'claim your daily reward',
  DISPLAY_NAME: 'change your display name',
  REDEEM_COUPON: 'redeem a coupon',
} as const;
